import React from 'react'
import laptop from '../../img/laptop.jpg'
import { withComponentLabel } from '../../utils/debug'
const Laptop = () => {
  return <img src={laptop}></img>
}

export default withComponentLabel(Laptop, 'Laptop')
